export default {

	init() {

		var container = document.querySelector('main.defaultTemplate');

		if( container ) {

			// -- woocheckout -- //

				if( document.body.classList.contains('woocommerce-checkout') ) {

					var autocompleteValue = 'off';

					if( !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime) ) {

						autocompleteValue = 'disabled';

					}

					container.querySelectorAll('.form-row input').forEach( function( input,index ) {

						input.setAttribute('autocomplete', autocompleteValue);

						if( !document.body.classList.contains('logged-in') ) {

							input.setAttribute('autofill', 'off');

						}

					});

				}

			// -- END -- //


		}

	}

}